import { secureStorage } from "@/utils/aes";
import { noauthApi, type ApiResponse } from "@/utils/api";
import { create } from "zustand";
import { persist, type StorageValue } from "zustand/middleware";
interface PubkeyState {
  pubkey: string;
  expiredAt: number;
  getPubkeyAction: () => Promise<string>;
  getPubkey: () => Promise<string>;
}
const get_next_monday_timestamp = () => {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const daysUntilNextMonday = (8 - dayOfWeek) % 7 || 7;
  const nextMonday = new Date(
    now.getTime() + daysUntilNextMonday * 24 * 60 * 60 * 1000,
  );
  nextMonday.setHours(0, 0, 0, 0);
  return nextMonday.getTime() - new Date().getTimezoneOffset() * 60000; // convert to UTC TimeZone timestamp
};
console.log(
  "Next Monday Timestamp:",
  get_next_monday_timestamp(),
  new Date(get_next_monday_timestamp()).toString(),
);
export const usePubkeyStore = create(
  persist<PubkeyState>(
    (set, get) => ({
      pubkey: "",
      expiredAt: 0,
      getPubkeyAction: async () => {
        const { data } =
          await noauthApi.get<ApiResponse<string>>("/auth/user/pubkey");
        set({
          pubkey: data.data!,
          expiredAt: get_next_monday_timestamp(),
        });
        return data.data!;
      },
      getPubkey: async () => {
        const storedPubkey = get().pubkey;
        if (storedPubkey) {
          return new Promise((resolve) => resolve(storedPubkey));
        }
        return get().getPubkeyAction();
      },
    }),
    {
      name: "encrypted-pubkey-storage",
      storage: {
        getItem: async (name) => {
          const str = localStorage.getItem(name);
          if (!str) return null;
          const value: StorageValue<PubkeyState> = JSON.parse(
            (await secureStorage.decrypt(str)) || "",
          );
          if (value && value.state.expiredAt > Date.now()) {
            return value;
          }
          return null;
        },
        setItem: async (name, value) => {
          const encrypted = await secureStorage.encrypt(JSON.stringify(value));
          localStorage.setItem(name, encrypted);
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
);
